export default "__VITE_ASSET__D5zti2dn__"